/* Adele Chérie — Product 2026 JS
   - Gallery thumbnail swap
   - Variant picker (option buttons → variant selection → price + URL + add btn)
   - Quantity stepper
   - Sticky cart bar mobile (visible on scroll past CTA)
*/
(function () {
  'use strict';

  // Stringhe localizzate iniettate da Liquid (fallback IT se assenti)
  var S = window.ACProductStrings || {};
  S.addToCart = S.addToCart || 'Aggiungi al carrello';
  S.add = S.add || 'Aggiungi';
  S.unavailable = S.unavailable || 'Non disponibile';
  S.soldOut = S.soldOut || 'Esaurito';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    // Use Shopify global money format if available
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney && window.theme && window.theme.moneyFormat) {
      return Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    // Fallback EUR
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function init() {
    var section = $('.ac-prod');
    if (!section) return;

    initGallery(section);
    initVariants(section);
    initQuantity(section);
    initSticky(section);
    initQuote(section);
  }

  /* ============ Gallery ============ */
  function initGallery(section) {
    var thumbs = $$('[data-ac-thumb]', section);
    var slides = $$('[data-ac-slide]', section);
    if (!thumbs.length || !slides.length) return;

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-ac-thumb');
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === btn);
          t.setAttribute('aria-selected', t === btn ? 'true' : 'false');
        });
        slides.forEach(function (s) {
          s.classList.toggle('is-active', s.getAttribute('data-ac-slide') === idx);
        });
      });
    });
  }

  /* ============ Variants ============ */
  function initVariants(section) {
    var dataScript = $('[data-ac-variants]', section);
    if (!dataScript) return;
    var variants;
    try { variants = JSON.parse(dataScript.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    var optionBtns = $$('[data-ac-option]', section);
    var variantIdInput = $('[data-ac-variant-id]', section);
    var priceNowEl = $('[data-ac-price-now]', section);
    var ctaPriceEl = $('[data-ac-cta-price]', section);
    var ctaBtn = $('[data-ac-add-btn]', section);
    var stickyPrice = $('[data-ac-sticky-price]', section);
    var stickyBtn = $('[data-ac-sticky-add]', section);

    var selected = {}; // { '1': value, '2': value, ... }

    // Init selected from active buttons
    optionBtns.forEach(function (b) {
      if (b.classList.contains('is-active')) {
        selected[b.getAttribute('data-ac-option')] = b.getAttribute('data-ac-value');
      }
    });

    /* ---- Raggruppamento immagini per colore (variant image grouping) ----
       La posizione dell'opzione "Colore" è iniettata da Liquid in data-ac-color-option.
       Ogni thumb/slide porta data-ac-color = alt text immagine (minuscolo).
       Regola: con un colore selezionato mostra solo i thumb di quel colore
       + quelli senza colore (alt vuoto = immagini comuni, es. packaging).
       Sicurezza: se nessuna immagine ha colore assegnato, oppure il colore scelto
       non ha foto dedicate, non filtra nulla (galleria mai vuota, zero regressioni). */
    var colorOptPos = section.getAttribute('data-ac-color-option') || '0';

    function normColor(s) { return (s || '').toLowerCase().trim(); }

    function filterGalleryByColor(colorVal) {
      if (!colorOptPos || colorOptPos === '0') return;
      var target = normColor(colorVal);
      var thumbs = $$('[data-ac-thumb]', section);
      if (!thumbs.length) return;

      var firstVisible = null;
      var activeVisible = false;
      var anyColored = false;

      thumbs.forEach(function (t) {
        var c = normColor(t.getAttribute('data-ac-color'));
        if (c !== '') anyColored = true;
        var show = (c === '' || c === target);
        t.style.display = show ? '' : 'none';
        if (show) {
          if (firstVisible === null) firstVisible = t;
          if (t.classList.contains('is-active')) activeVisible = true;
        }
      });

      // Nessun alt colore impostato OR colore senza foto dedicate -> mostra tutto.
      if (!anyColored || firstVisible === null) {
        thumbs.forEach(function (t) { t.style.display = ''; });
        return;
      }
      // Se la foto attiva è stata nascosta, porta in primo piano la prima del colore.
      if (!activeVisible) firstVisible.click();
    }

    // Filtro iniziale sul colore già selezionato al caricamento pagina.
    if (colorOptPos !== '0' && selected[colorOptPos]) {
      filterGalleryByColor(selected[colorOptPos]);
    }

    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.getAttribute('data-ac-option');
        var val = btn.getAttribute('data-ac-value');
        selected[pos] = val;
        // Update active state same group
        optionBtns.forEach(function (b) {
          if (b.getAttribute('data-ac-option') === pos) {
            b.classList.toggle('is-active', b === btn);
          }
        });
        // Update option value label
        var labelEl = section.querySelector('[data-ac-option-value="' + pos + '"]');
        if (labelEl) labelEl.textContent = val;
        // Variant image grouping: se cambia il colore, filtra la galleria per colore.
        if (pos === colorOptPos) filterGalleryByColor(val);
        // Match variant
        updateVariant();
      });
    });

    function updateVariant() {
      var match = variants.find(function (v) {
        return Object.keys(selected).every(function (pos) {
          var optKey = 'option' + pos;
          return v[optKey] === selected[pos];
        });
      });
      if (!match) return;

      if (variantIdInput) variantIdInput.value = match.id;
      if (priceNowEl) priceNowEl.textContent = formatMoney(match.price);

      var available = match.available;
      if (ctaBtn) {
        ctaBtn.disabled = !available;
        // Aggiorna il prezzo unitario sul bottone per il calcolo del totale
        ctaBtn.setAttribute('data-ac-unit-price', String(match.price));
        var ctaText = ctaBtn.querySelector('.ac-prod__cta-text');
        if (ctaText) {
          ctaText.innerHTML = available
            ? S.addToCart + ' — <span data-ac-cta-price>' + formatMoney(match.price) + '</span>'
            : S.unavailable;
        }
      }
      // Ricalcola il totale (qty × nuovo unit price)
      refreshCtaTotal(section);
      if (stickyBtn) {
        stickyBtn.disabled = !available;
        stickyBtn.textContent = available ? S.add : S.soldOut;
      }

      // Update URL (preserve scroll)
      if (history.replaceState && match.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }

      // Update featured image (gallery swap to variant image if exists)
      if (match.featured_media && match.featured_media.position) {
        var slideIdx = String(match.featured_media.position - 1);
        var targetSlide = section.querySelector('[data-ac-slide="' + slideIdx + '"]');
        var targetThumb = section.querySelector('[data-ac-thumb="' + slideIdx + '"]');
        if (targetThumb) targetThumb.click();
      }
    }
  }

  /* ============ Quantity ============ */
  function initQuantity(section) {
    var input = $('.ac-prod__qty-input', section);
    var btns = $$('[data-ac-qty]', section);
    if (!input) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-ac-qty'), 10) || 0;
        var current = parseInt(input.value, 10) || 1;
        var next = Math.max(1, current + delta);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);
      if (!v || v < 1) input.value = 1;
      refreshCtaTotal(section);
      syncQuoteBlock(section);
    });
    input.addEventListener('input', function () {
      refreshCtaTotal(section);
      syncQuoteBlock(section);
    });

    // Init: setta il totale iniziale (qty=1 quindi totale=unit price, ma per sicurezza)
    refreshCtaTotal(section);
  }

  /* ============ CTA total (totale dinamico nel bottone Aggiungi al carrello) ============ */
  function refreshCtaTotal(section) {
    var qtyInput = $('.ac-prod__qty-input', section);
    var ctaBtn = $('[data-ac-add-btn]', section);
    var ctaPriceEl = $('[data-ac-cta-price]', section);
    if (!qtyInput || !ctaBtn || !ctaPriceEl) return;
    var unitPrice = parseInt(ctaBtn.getAttribute('data-ac-unit-price'), 10);
    if (isNaN(unitPrice)) return;
    var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    var total = unitPrice * qty;
    ctaPriceEl.textContent = formatMoney(total);

    // Sticky mobile bar: aggiorna anche lì se presente
    var stickyPrice = $('[data-ac-sticky-price]', section);
    if (stickyPrice) stickyPrice.textContent = formatMoney(total);
  }

  /* ============ Quote request block (grandi quantità) ============ */
  function syncQuoteBlock(section) {
    var quote = $('[data-ac-quote]', section);
    var input = $('.ac-prod__qty-input', section);
    if (!quote || !input) return;
    var threshold = parseInt(quote.getAttribute('data-ac-quote-threshold'), 10) || 50;
    var qty = parseInt(input.value, 10) || 1;
    var qtyField = $('[data-ac-quote-qty-field]', quote);
    var qtyLabel = $('[data-ac-quote-qty-label]', quote);
    if (qtyField) qtyField.value = String(qty);
    if (qtyLabel) qtyLabel.textContent = String(qty);

    var wasHidden = quote.hasAttribute('hidden');
    if (qty >= threshold) {
      if (wasHidden) {
        quote.removeAttribute('hidden');
        quote.classList.add('is-revealed');
        // Smooth scroll into view solo la prima volta in sessione
        if (!quote.dataset.acScrolled) {
          quote.dataset.acScrolled = '1';
          setTimeout(function () {
            quote.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 250);
        }
      }
    } else {
      quote.setAttribute('hidden', '');
      quote.classList.remove('is-revealed');
    }
  }
  function initQuote(section) {
    // Sync variante variant_id quando cambia
    var variantInputs = $$('input[name="contact[variant_id]"]', section);
    var buyVariantInput = $('[data-ac-variant-id]', section);
    if (buyVariantInput) {
      var observer = new MutationObserver(function () {
        variantInputs.forEach(function (vi) { vi.value = buyVariantInput.value; });
      });
      observer.observe(buyVariantInput, { attributes: true, attributeFilter: ['value'] });
    }
    // Init iniziale (caso qty default >= soglia)
    syncQuoteBlock(section);

    // Invio richiesta al servizio PDF (best-effort: non blocca né sostituisce
    // il submit nativo Shopify, che resta la notifica interna di riferimento)
    var quote = $('[data-ac-quote]', section);
    var form = $('#ac-prod-quote-form', section);
    var endpoint = quote && quote.getAttribute('data-ac-quote-endpoint');
    if (form && endpoint) {
      form.addEventListener('submit', function () {
        try {
          var data = new FormData(form);
          if (data.get('contact[website]')) return; // honeypot: probabile bot
          var payload = {
            name: data.get('contact[name]') || '',
            email: data.get('contact[email]') || '',
            phone: data.get('contact[telefono]') || '',
            message: data.get('contact[note]') || '',
            product: data.get('contact[product_title]') || '',
            productUrl: data.get('contact[product_url]') || '',
            quantity: data.get('contact[quantity]') || '',
            eventType: data.get('contact[event_type]') || '',
            eventDate: data.get('contact[event_date]') || '',
            unitPriceCents: data.get('contact[unit_price_cents]') || '',
            productImageUrl: data.get('contact[product_image]') || '',
            isSophieMariage: data.get('contact[is_sophie_mariage]') === 'true'
          };
          fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            keepalive: true
          }).catch(function () {});
        } catch (e) {}
      });
    }
  }

  /* ============ Sticky cart bar mobile ============ */
  function initSticky(section) {
    var sticky = $('[data-ac-sticky]', section);
    var buyForm = $('[data-ac-buy-form]', section);
    var stickyBtn = $('[data-ac-sticky-add]', section);
    if (!sticky || !buyForm) return;

    // Show sticky when buy form scrolled out of viewport
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          sticky.classList.remove('is-visible');
          sticky.setAttribute('aria-hidden', 'true');
        } else {
          // Only show if scrolled past (not before)
          var rect = buyForm.getBoundingClientRect();
          if (rect.bottom < 0) {
            sticky.classList.add('is-visible');
            sticky.setAttribute('aria-hidden', 'false');
          }
        }
      });
    }, { threshold: 0 });
    observer.observe(buyForm);

    // Click sticky → submit form
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var submitBtn = buyForm.querySelector('[data-ac-add-btn]');
        if (submitBtn && !submitBtn.disabled) {
          buyForm.requestSubmit ? buyForm.requestSubmit() : buyForm.submit();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
